import theme from "@/theme";
import { SxProps, Theme } from "@mui/material/styles";

type Styles = {
  formRoot: SxProps<Theme>;
  sectionHeader: SxProps<Theme>;
  sectionHeaderText: SxProps<Theme>;
  inputsBlock: SxProps<Theme>;
  inputGroup: SxProps<Theme>;
  label: SxProps<Theme>;
  input: SxProps<Theme>;
  endAdornment: SxProps<Theme>;
  iconButton: SxProps<Theme>;
  Link: SxProps<Theme>;
};

export const styles: Styles = {
  formRoot: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },

  sectionHeader: {
    display: "flex",
    flexDirection: "column",
    px: "16px",
    py: "12px",
    gap: "10px",
    borderBottom: "1px solid #f5f5f5",
  },

  sectionHeaderText: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: 0,
    color: "#7D8690",
  },

  inputsBlock: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    px: "16px",
    py: "10px",
  },

  inputGroup: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  label: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "15px",
    lineHeight: "24px",
    color: "#292929",
    fontStyle: "Medium",
    letterSpacing: 0,
  },

  input: {
    width: "100%",
    height: "50px",
    borderRadius: "999px",
    maxWidth: "408px",
    "& .MuiOutlinedInput-notchedOutline": { borderColor: "#E4E7E9" },
    "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#C6CACE" },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.palette.custom.mainBlue,
      borderWidth: "1px",
    },

    "& .MuiInputBase-input::placeholder": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "22px",
      letterSpacing: 0,
      color: "#C6CACE",
      opacity: 1,
    },
    "& .MuiInputBase-input": {
      fontFamily: "Inter, sans-serif",
      fontWeight: 500,
      fontSize: "15px",
      lineHeight: "20px",
      letterSpacing: "-0.02em",
      color: "#383C40",
      padding: "12px 16px",
      "&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus": {
        WebkitBoxShadow: "0 0 0 1000px #FFFFFF inset",
        WebkitTextFillColor: "#383C40",
        transition: "background-color 5000s ease-in-out 0s",
      },
    },
  },

  endAdornment: {
    "& svg": {
      display: "block",
      width: 25,
      height: 25,
    },
  },

  iconButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    lineHeight: 0,
  },

  Link: {
    fontFamily: "Inter, sans-serif",
    fontWeight: 600,
    fontSize: "13px",
    lineHeight: "18px",
    letterSpacing: "0%",
    textDecoration: "underline",
    textDecorationColor: theme.palette.custom.mainBlue,
    textDecorationThickness: "1px",
    textUnderlineOffset: "3px",
    cursor: "pointer",
  },
};
